<template>

    <div style="padding-top: 26px; padding-bottom: 20px; flex-grow: 1; flex-shrink: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; scroll-behavior: smooth;">
        <div id="gallery_list_before_after">

            <div v-for="(item, idx) in items.slice(0,maxItems)"
                 :class="idx < 6 ? 'pm-animation-fade-in-slide-down' : ''" :style="'--delay: '+idx * 50+'ms'"
                 :key="item.id" @click.stop="openViewer(idx)" style="margin: 0 24px 32px 24px;">


                <div
                    :id="'pm-gallery-media-grid-thumb-' + item.id"
                    :data-src="item.src"
                    :data-id="item.id"
                    class="editable pm-gallery-media-before-after"
                    :data-idx="idx+1"
                    :class="(idx+1)%10 === 0 ? 'pm-infinite-scroll-observable' : ''"
                >
                    <div class="pm-gallery-media-before"
                         :style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg') + '\')'">
                    </div>
                    <div class="pm-gallery-media-after"
                         :style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg') + '\')'">
                    </div>
                </div>
                <span style="color: #555; font-size: 13px;">
                    <b style="font-weight: 600;">Case #{{ idx + 1 }}</b> - {{ titles[item.groups[0]] }}
                </span>
            </div>
        </div>

        <pm-premium-lock-screen v-if="!$IAP.hasAccessToComponent('photos')" track-label="lock_screen_photos_before_after" />
    </div>
</template>

<style>
.pm-gallery-media-before-after {
    height: Calc(100vw * 0.29);
    position: relative;
    display: flex;
    overflow: hidden;
    padding: 10px;
    background: #ddd;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .15);
    margin-bottom: 5px;
}

.pm-gallery-media-before {
    margin-right: 5px;
    width: 50%;
    height: 100%;
    background-size: cover;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .25);
}

.pm-gallery-media-after {
    margin-left: 5px;
    width: 50%;
    height: 100%;
    background-size: cover;
    background-position: right bottom;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .25);
}

@media (min-width: 700px) {
    .gallery--premium-badge {
        font-size: 16px !important;
    }

    .gallery--premium-badge svg {
        width: 40px;
        height: 40px;
    }
}
</style>

<script>
import MediaList from "../../configs/gallery/media";
import ChildCategoryConfig from "../../configs/gallery/child-categories.json";
import PmPremiumLockScreen from "@/components/core/premium-lock-screen";

export default {
    name: "PmModGalleryBeforeAfter",
    components: {
        PmPremiumLockScreen
    },
    data: () => ({
        items: [],
        maxItems: 5,
        titles: {},
    }),

    created() {
        this.items = this.getItems();
    },

    mounted() {
        window.setTimeout(() => {
            this.maxItems = 20;
            this.$nextTick(() => {
                this.initInfiniteScroll();
            });
        }, 400);
    },

    activated() {
        this.maxItems = 20;
        this.initInfiniteScroll();
    },

    beforeDestroy() {
        this.observer.disconnect();
    },

    computed: {
        is4in1() {
            return this.$packageName === 'com.denticalc.4in1';
        },
    },

    methods: {
        initInfiniteScroll() {
            try {
                this.observer = new IntersectionObserver(entry => {
                    if (entry[0].isIntersecting) {
                        this.observer.unobserve(entry[0].target);
                        let idx = entry[0].target.dataset.idx;
                        if (this.items.length <= this.maxItems) return;
                        if (this.maxItems < idx + 20) {
                            this.maxItems = parseInt(idx) + 20;
                            this.$nextTick(() => {
                                const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");
                                if (observableEls) {
                                    this.observer.observe(observableEls[observableEls.length - 1]);
                                }
                            });
                        }
                    }
                });

                const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");

                if (observableEls) {
                    observableEls.forEach(el => {
                        this.observer.observe(el);
                    });
                }
            } catch (error) {
                captureException(error);
                // Show all items on infinite scroll failure
                this.maxItems = 999;
            }
        },

        openViewer(idx) {
            if (!this.$IAP.hasAccessToComponent('photos')) this.showUpgrade();
            else {
                const params = {
                    start: idx,
                    items: this.items,
                    galleryId: 0,
                    galleryTitle: "Before-after",
                    categoryTitle: "Before-after"
                };
                this.$emit('openViewer', params);
            }
        },

        reload() {
            this.items = this.getItems();
        },

        getGalleryTitle(id) {
            let title = "";
            ChildCategoryConfig.forEach((i) => {
                if (i.id === id) title = i.title.en ? i.title.en : "";
            })
            return title;
        },

        getItems() {
            const imgMap = new Map();
            const items = MediaList.filter((item) => {
                if (!item.tags[0].toLowerCase().includes('before-after')) return false;
                if (imgMap.has(item.src)) return false;
                imgMap.set(item.src, 1);
                return (item.width === 626 && item.height === 800);
            });

            const galleryIds = [
                50, // crown
                54, // bridge
                51, // veneer
                64, // dentures
                75, // temporary
                47, // comparisons
                4, // implants
                1, // all-on-4
                10, // sinus lift
                13, // bone graft
                15, // tooth surgeries
                24, // gum surgery
                26, // perio diseases
                79, // perio treatments
                34, // post
                35, // fillings
                36, // inlay
                42, // root canal
                89, // braces
                17, // orhognathic
                111, // biting
                112, // palatal
                78, // whitening
                103, // dental problems
                104, // anatomy
            ];

            galleryIds.forEach(id => {
                this.titles[id] = this.getGalleryTitle(id);
            });

            items.sort((a,b) => {
                const i1 = galleryIds.indexOf(a.groups[0]);
                const i2 = galleryIds.indexOf(b.groups[0]);
                if (i1 < i2) return -1;
                if (i1 > i2) return 1;
                return 0;
            });

            const galleryOrdering = [];

            return items;
        },
    },
};

</script>
